function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Badge } from "@neru/ui";
import { FormValueSetter } from "../Form/FormValueSetter";
import { isEmpty } from "../../utils";
import { formatDateTime } from "../../utils/date-time";
import { isArrayOfStrings } from "../../utils/validators";
var mapNamesToSelectedFilters = function(params, options) {
    return params.map(function(param) {
        var _options_find;
        var _options_find_name;
        return (_options_find_name = (_options_find = options.find(function(option) {
            return option.value === param;
        })) === null || _options_find === void 0 ? void 0 : _options_find.name) !== null && _options_find_name !== void 0 ? _options_find_name : param;
    }).join(", ");
};
/**
 * AppliedFilters shows a list of applied filters in the form of buttons, upon
 * clicking on which this particular option is reset.
 *
 * @param flatFilter    Applied filters as a flat array with plain values.
 * @param optionNames   Array of filter option names.
 * @param rules         Types of filter options (date_range, in_range, eq, etc.)
 *                      which determines the way the applied filter is displayed.
 */ export var AppliedFilters = function(param) {
    var flatFilter = param.flatFilter, _param_initFormElements = param.initFormElements, initFormElements = _param_initFormElements === void 0 ? function(x) {
        return x;
    } : _param_initFormElements, optionNames = param.optionNames, optionValueNames = param.optionValueNames, rules = param.rules;
    var date_range = rules.date_range, _rules_eq = rules.eq, eq = _rules_eq === void 0 ? [] : _rules_eq, _rules_ilike = rules.ilike, ilike = _rules_ilike === void 0 ? [] : _rules_ilike, in_range = rules.in_range, _rules_is_null = rules.is_null, is_null = _rules_is_null === void 0 ? [] : _rules_is_null, _rules_like = rules.like, like = _rules_like === void 0 ? [] : _rules_like;
    var formattedFilters = flatFilter ? Object.entries(flatFilter).reduce(function(appliedFilter, param) {
        var _param = _sliced_to_array(param, 2), fieldName = _param[0], value = _param[1];
        // Don't show filter by name in applied filters (search input field)
        if (isEmpty(value) || !optionNames[fieldName]) {
            return appliedFilter;
        }
        var readableFilterValue = value;
        if (((is_null === null || is_null === void 0 ? void 0 : is_null.includes(fieldName)) || (in_range === null || in_range === void 0 ? void 0 : in_range.includes(fieldName))) && isArrayOfStrings(value)) {
            if (optionValueNames === null || optionValueNames === void 0 ? void 0 : optionValueNames[fieldName]) {
                readableFilterValue = mapNamesToSelectedFilters(value, optionValueNames[fieldName]);
            } else {
                readableFilterValue = value.join(", ");
            }
        } else if ((date_range === null || date_range === void 0 ? void 0 : date_range.includes(fieldName)) && Array.isArray(value)) {
            readableFilterValue = "".concat(formatDateTime(value[0]), " - ").concat(formatDateTime(value[1]));
        } else if (_to_consumable_array(eq).concat(_to_consumable_array(ilike), _to_consumable_array(like)).includes(fieldName)) {
            readableFilterValue = value;
        }
        return _object_spread_props(_object_spread({}, appliedFilter), _define_property({}, fieldName, readableFilterValue));
    }, {}) : [];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: Object.entries(formattedFilters).map(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            return initFormElements(/*#__PURE__*/ _jsx(FormValueSetter, {
                name: key,
                submit: true,
                children: /*#__PURE__*/ _jsx(Badge, {
                    className: "mr-2",
                    connotation: "cta",
                    icon: "close-small-solid",
                    layout: "soft",
                    shape: "pill",
                    trailingIcon: true,
                    children: "".concat(optionNames[key], ": ").concat(value)
                })
            }, key));
        })
    });
};

//# sourceMappingURL=AppliedFilters.js.map